import React from 'react';
import styled from 'styled-components';
import { TranslationAction, translationActions } from '../../helper/translationHelpers';
import { BiCheck, BiX } from 'react-icons/bi';
import { observer } from 'mobx-react-lite';
import { runInAction } from 'mobx';
const Element = styled.span.withConfig({
  displayName: "TranslationActionSelection__Element",
  componentId: "sc-xsbm8d-0"
})(["input[type=\"radio\"]{opacity:0;position:fixed;width:0;}&.discard{label{border-color:red;color:red;}input[type=\"radio\"]:checked + label{color:white;background-color:red;}}&.notset{label{border-color:#AAA;}input[type=\"radio\"]:checked + label{background-color:lightgrey;}}&.commit{label{border-color:#4c4;color:#4c4;}input[type=\"radio\"]:checked + label{color:white;background-color:#4c4;}}label{display:inline-block;background-color:white;margin:1px;padding:6px 4px 4px 6px;border:2px solid #444;border-radius:8px;width:2em;height:2em;overflow:hidden;}label:hover{}input[type=\"radio\"]:focus + label{border-color:black;}input[type=\"radio\"]:checked + label{}"]);
const LabelIcon = {
  [TranslationAction.Discard]: /*#__PURE__*/React.createElement(BiX, null),
  [TranslationAction.NotSet]: /*#__PURE__*/React.createElement("div", null),
  [TranslationAction.Commit]: /*#__PURE__*/React.createElement(BiCheck, null)
};
export const TranslationActionSelection = observer(({
  translation,
  gender
}) => {
  const {
    translatedStringModelId,
    translationsByGender
  } = translation;
  const translationDataForGender = translationsByGender.get(gender);
  const {
    action
  } = translationDataForGender;
  const groupName = translatedStringModelId + gender + "action";
  return /*#__PURE__*/React.createElement(React.Fragment, null, translationActions.map(translationAction => /*#__PURE__*/React.createElement(Element, {
    className: translationAction.toLowerCase(),
    key: translationAction
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    id: groupName + translationAction,
    name: groupName,
    value: translationAction,
    checked: action === translationAction,
    onChange: () => {
      runInAction(() => {
        translationDataForGender.action = translationAction;
      });
    }
  }), /*#__PURE__*/React.createElement("label", {
    htmlFor: groupName + translationAction
  }, LabelIcon[translationAction]))));
});